export default () => {
    return {
        mounted(delay = this.$store.animationDelay, scrollTrigger = true, direction = 104) {
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.container
                };
            }

            const reveal = gsap.timeline({ scrollTrigger: stSettings });

            reveal
                .to(this.$refs.cover, {
                    duration: 0.9,
                    yPercent: direction,
                    delay: delay,
                    ease: 'circ.inOut'
                })
                .set(this.$refs.container, { autoAlpha: 0 });
        }
    };
};
